export default __webpack_public_path__ + "static/deusdao-67b5309e8afec99cd2f24daa6a4e5989.jpg";